import type { GameCommand } from "../../semantic-command";
import type { GameplayEvaluationReceipt } from "../shared/adapter";
import type { QuizSpec } from "./spec";

/**
 * Quiz's own content (question text/answers) is validated closed-world by
 * the parser already, so a schema failure here means the model produced
 * something the parser would also reject on re-validation -- there is no
 * bounded numeric knob that fixes bad content. The only real repair lever
 * is goalCorrect versus the question count actually shipped.
 */
export function repairCommandsForQuiz(spec: QuizSpec, failedReceipt: GameplayEvaluationReceipt): readonly GameCommand[] | null {
  const failed = new Set(failedReceipt.checks.filter((check) => !check.passed).map((check) => check.id));
  if (failed.has("goal-achievable")) {
    return [{ type: "set-params", params: { goalCorrect: Math.max(1, spec.params.questions.length - 1) } }];
  }
  return null;
}
